import { render, staticRenderFns } from "./FormOrchestration.vue?vue&type=template&id=70ac7a0d&scoped=true"
import script from "./FormOrchestration.vue?vue&type=script&lang=js"
export * from "./FormOrchestration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ac7a0d",
  null
  
)

export default component.exports